import { render } from "./AutoReplayManagement.vue?vue&type=template&id=bd83faa6&scoped=true"
import script from "./AutoReplayManagement.vue?vue&type=script&lang=js"
export * from "./AutoReplayManagement.vue?vue&type=script&lang=js"

import "./AutoReplayManagement.vue?vue&type=style&index=0&id=bd83faa6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd83faa6"]])

export default __exports__